import { jsx as e, jsxs as C } from "react/jsx-runtime";
import B from "classnames";
import { kebabCase as G } from "lodash";
import { forwardRef as H, useCallback as E, useMemo as I, cloneElement as J, isValidElement as Q } from "react";
import { useFocusFirstItemWhenAutoFocus as U } from "./index.es5533.js";
import o from "./index.es5538.js";
import { mergeTooltipPropsForSmartTooltip as X } from "./index.es5534.js";
import { useTheme as Y } from "./index.es190.js";
import { Switch as Z } from "./index.es124.js";
import { Checkbox as _ } from "./index.es31.js";
import { Icon as K } from "./index.es157.js";
import { Skeleton as D } from "./index.es71.js";
import { SmartTooltipWrapper as L } from "./index.es525.js";
import { mergeRefs as k } from "./index.es551.js";
import { getDisabledAria as tt } from "./index.es530.js";
import { onKeyDownEnterAndSpace as rt } from "./index.es526.js";
const et = H(
  ({
    multi: u,
    id: M,
    value: N,
    isSelected: i,
    isDisabled: r,
    wrapperStyle: b,
    label: c,
    RightComponent: h,
    autoFocus: O = !1,
    hasDivider: P,
    isLocked: t,
    testId: x,
    tooltip: s,
    isLoading: T = !1,
    lockedTooltip: d,
    onItemSelect: n,
    onClick: l,
    onKeyDown: g,
    onLockedClick: p,
    onMouseEnter: j,
    onMouseLeave: R
  }, y) => {
    const { refForFirstItem: $ } = U(O), a = `${x ? `${G(x)}-` : ""}multi-select-item`, S = Y(), F = B(
      o.item,
      {
        [o.hasDivider]: P,
        [o.isDisabled]: r,
        [o.isSelected]: i,
        [o.isLocked]: t
      },
      "placer-ui-multi-select-item"
    ), v = E(() => {
      !t && !r && (n == null || n(N));
    }, [r, t, n, N]), w = E(
      (m) => {
        var A;
        t ? p == null || p(m) : (l == null || l(m), (A = $.current) == null || A.querySelector("button").click());
      },
      [t, l, p, $]
    ), V = (m) => {
      g == null || g(m), rt(m, w, !1);
    }, W = I(() => t ? /* @__PURE__ */ e(
      "span",
      {
        className: o.RightComponent,
        "data-testid": `${a}-locked`,
        "aria-hidden": "true",
        children: /* @__PURE__ */ e(K, { type: "Lock", size: 16, "aria-label": "Locked" })
      }
    ) : h ? /* @__PURE__ */ e(
      "span",
      {
        className: o.RightComponent,
        "data-testid": `${a}-right-component`,
        "aria-hidden": "true",
        children: J(h, {
          ...r ? { color: "outline" } : {},
          outline: r ? "disabled" : "default-gray",
          "aria-hidden": !0
        })
      }
    ) : null, [h, r, a, t]);
    let f = Q(c) ? c : String(c);
    t && (f += " (Locked)");
    const q = I(() => {
      const m = {
        checked: i,
        disabled: r,
        isLocked: t,
        "data-testid": a,
        label: f,
        "aria-describedby": d || s ? `${a}-tooltip` : void 0,
        onCheckedChange: v
      };
      return u === "switch" ? /* @__PURE__ */ e(Z, { ...m }) : /* @__PURE__ */ e(_, { ...m, isPartial: u === "partial-checkbox" });
    }, [
      i,
      r,
      t,
      a,
      f,
      d,
      s,
      v,
      u
    ]);
    if (T)
      return /* @__PURE__ */ e("div", { className: F, style: b, ref: y, children: /* @__PURE__ */ e(
        D,
        {
          isVisible: !0,
          height: "16px",
          width: "100%",
          margin: `${S.spacings.s}`,
          "aria-label": "skeleton loading for item",
          "aria-busy": !0
        }
      ) });
    const z = X({ tooltip: s, lockedTooltip: d });
    return /* @__PURE__ */ e(
      L,
      {
        tooltip: z,
        isLocked: t,
        itemLabel: f,
        isDisabled: r,
        isOverflowing: !1,
        testId: `${a}-tooltip`,
        ref: k($, y),
        children: /* @__PURE__ */ C(
          "div",
          {
            className: F,
            style: b,
            "data-testid": `${a}-container`,
            "data-selected": i,
            onMouseEnter: j,
            onMouseLeave: R,
            onClick: w,
            onKeyDown: V,
            id: M,
            role: "presentation",
            ...tt(!!r, !!s, "none"),
            children: [
              /* @__PURE__ */ e("div", { className: o.multiSelectComponent, children: q }),
              W
            ]
          }
        )
      }
    );
  }
);
et.displayName = "MultiSelectItem";
export {
  et as MultiSelectItem
};
//# sourceMappingURL=index.es84.js.map
